import apiHandler from "../core/apiHandler";

const productApi = apiHandler('products');
export default productApi;